
import { defineComponent, watch, ref, reactive, computed, nextTick } from 'vue'
import { useStore } from 'vuex'
import { NuxeoCalOrderRequest } from '@/contracts/api/RequestContracts'
import { ApiPaymentResponse, NuxeoOrderResponse, NuxeoOrder422Response } from '@/contracts/api/ResponseContracts'
import { axiosPostPayment } from '@/composables/api'
import { nuxeoCalCreateGrant } from '@/composables/nuxeo'

export default defineComponent(
{
    name: 'Pay',
    setup()
    {
        // Use vuex:
        const store = useStore()
        // Get authentication status:
        const isAuthenticated = store.getters['auth/isAuthenticated']
        const authenticatedUser = store.getters['auth/getUser']
        // Get basket from store:
        const basketItems = computed(() =>
        {
            return store.getters['basket/getBasket']
        })
        // Reactive requests var:
        const paymentFormData = reactive({} as ApiPaymentResponse)
        const paymentForm = ref(null as any)
        // Handle preparing caldocs:
        const prepareCaldocs = async() =>
        {
            for(let i = 0; i < basketItems.value.length; i++)
            {
                // Check doc type to determine if we need to generate grant doc:
                if(basketItems.value[i]['hmctsgrant:grantdocTypeOf'] === 2 && basketItems.value[i].uid === undefined)
                {
                    // Set caldoc:
                    const caldoc = basketItems.value[i]
                    // Generate ID:
                    const digits = '' + new Date().valueOf()
                    const id = 'COW' + digits.substr(digits.length - 13)
                    const dateOfProbate = new Date(caldoc['hmctsgrant:dateofprobate'])
                    const dateOfProbateString = dateOfProbate.getUTCFullYear() + '-' + ((dateOfProbate.getUTCMonth() + 1) < 10 ? '0' : '') + (dateOfProbate.getUTCMonth() + 1) + '-' + (dateOfProbate.getUTCDate() < 10 ? '0' : '') + dateOfProbate.getUTCDate()
                    const dateOfDeath = new Date(caldoc['hmctsgrant:dateofdeath'])
                    const dateOfDeathString = dateOfDeath.getUTCFullYear() + '-' + ((dateOfDeath.getUTCMonth() + 1) < 10 ? '0' : '') + (dateOfDeath.getUTCMonth() + 1) + '-' + (dateOfDeath.getUTCDate() < 10 ? '0' : '') + dateOfDeath.getUTCDate()
                    // Set params for order query:
                    const orderParams =
                    {
                        grantTitle: id,
                        calendarIndexDocs: caldoc.caldoc_uid,
                        dateOfProbate: dateOfProbateString,
                        registryOfficeName: caldoc['hmctsgrant:registryofficename'],
                        surname: caldoc['hmctsgrant:surname'],
                        dateOfDeath: dateOfDeathString,
                        firstnames: caldoc['hmctsgrant:firstnames'],
                        folioNumber: String(caldoc['hmctsgrant:folionumber'])
                    }
                    await generateGrant(i, orderParams)
                }
            }
            return true
        }
        const generateGrant = async function(index: number, orderParams: NuxeoCalOrderRequest): Promise<any>
        {
            return new Promise((resolve) =>
            {
                // Create  calorder for grant doc:
                nuxeoCalCreateGrant(
                orderParams,
                function(response: NuxeoOrderResponse)
                {
                    store.commit('basket/transformCalItem', { index: index, uid: response.uid, price: response.properties['hmctsgrant:price'] })
                    resolve(true)
                },
                function(response: NuxeoOrder422Response)
                {
                    store.commit('basket/transformCalItem', { index: index, uid: response.details, price: 1.5 })
                    resolve(true)
                })
            })
        }
        // Handle email submission:
        const makePayment = () =>
        {
            // Set amount:
            let price = 0
            for(let i = 0; i < basketItems.value.length; i++)
            {
                price += basketItems.value[i]['hmctsgrant:price']
            }
            // Set domain:
            const currentDomain = location.protocol + '//' + location.host
            // Call payment:
            const paymentData = axiosPostPayment('/payment/prepare',
            {
                AMOUNT: price * 100,
                CURRENCY: 'GBP',
                LANGUAGE: 'en_US',
                ACCEPTURL: currentDomain + '/payment/success',
                DECLINEURL: currentDomain + '/payment/declined',
                EXCEPTIONURL: currentDomain + '/payment/exception',
                CANCELURL: currentDomain + '/payment/canceled'
            })
            watch(paymentData, (response: ApiPaymentResponse) =>
            {
                Object.assign(paymentFormData, response)
                if(response.PaymentProcessingURL !== undefined)
                {
                    submitForm()
                }
            })
        }

        // Submit form after next tick to wait for form values to update:
        const submitForm = async() =>
        {
            await nextTick()
            paymentForm.value.submit()
        }

        // Start payment if authenticated:
        if(isAuthenticated)
        {
            prepareCaldocs()
            .then(() =>
            {
                // Make payment:
                makePayment()
            })
        }

        // Return data:
        return {
            isAuthenticated,
            makePayment,
            paymentFormData,
            paymentForm
        }
    }
})
